import { Steps } from 'antd';
import { CardDetails } from '../../../../../../common/components/CardDetails/CardDetails';
import style from "./style.module.scss"
import dayjs from 'dayjs';

type ShiftingOperationsDetailsTypes = {
    initialValue?: any
}
function ShiftingOperationsDetails({initialValue}: ShiftingOperationsDetailsTypes) {

    const renderValue = (value : any /* string | number | boolean */) => {
        return value ? value : "-";
      };

    const chalandValue = () => {
        return (initialValue?.isBargeUsed ? "oui" : "non");
    }

    const shiftingSteps = initialValue?.shiftingSteps ?? [];

    const sortedSteps = [...shiftingSteps].sort(
      (a, b) => a.stepOrder - b.stepOrder
    );
    
    const stepItems = sortedSteps.map((step, index) => ({
      title: step.locationLabel,
      status: 'finish' as const,
      icon: (
        <div
          style={{
            backgroundColor: '#1677ff',
            color: '#fff',
            borderRadius: '50%',
            width: 24,
            height: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: 12,
          }}
        >
          {index + 1}
        </div>
      ),
    }));

  return (
    <div>
      <div className={`${style.form__input_label}`}>Informations</div>
      <CardDetails className="d-flex gap-2 flex-column mt-2">
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Marchandise : </span>
                <span className={style.details__value}>{renderValue(initialValue?.loadType?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Type de shifting : </span>
                <span className={style.details__value}>{renderValue(initialValue?.shiftingType?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Identifiant : </span>
                <span className={style.details__value}>{renderValue(initialValue?.uniqueIdentifier)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Tonnage (T) : </span>
                <span className={style.details__value}>{renderValue(initialValue?.tonnage)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>État : </span>
                <span className={style.details__value}>{renderValue(initialValue?.loadFillingStatus?.name)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Nature : </span>
                <span className={style.details__value}>{renderValue(initialValue?.loadUnit)}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Type : </span>
                <span className={style.details__value}>{renderValue(initialValue?.loadProperty)}</span>

              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Date : </span>
                <span className={style.details__value}>{renderValue(dayjs(initialValue?.startAt, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YY"))}</span>
              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Heure de début : </span>
                <span className={style.details__value}>{renderValue(dayjs(initialValue?.startAt, "DD/MM/YYYY HH:mm").format("HH:mm"))}</span>

              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Heure de fin : </span>
                <span className={style.details__value}>{renderValue(dayjs(initialValue?.endAt, "DD/MM/YYYY HH:mm").format("HH:mm"))}</span>

              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Chaland : </span>
                <span className={style.details__value}>{renderValue(chalandValue())}</span>

              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Référence chaland : </span>
                <span className={style.details__value}>{renderValue(initialValue?.bargeMaterial?.reference)}</span>

              </div>
              <div className={style.details__item}>
                <span className={style.details__subtitle}>Motif : </span>
                <span className={style.details__value}>{renderValue(initialValue?.reason)}</span>

              </div>
      </CardDetails>
      <div className={`${style.form__input_label} mt-4`}>Progression</div>
      <CardDetails className={`${style.details__progression_card} mt-2`}>
              <div className={style.details__progression}>
                <span className={style.details__steps}>
                <Steps
                  size="small"
                  items={stepItems}
                  direction="vertical"
                />
                </span> 
              </div>
              </CardDetails>
            
    </div>
  )
}

export default ShiftingOperationsDetails